import { render, staticRenderFns } from "./AdminStepAdd.vue?vue&type=template&id=2cfc17a6&"
import script from "./AdminStepAdd.vue?vue&type=script&lang=js&"
export * from "./AdminStepAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports